import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardHeader,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
  Form,
  FormInput,
  Button
} from "shards-react";
import UploadDisplayLogo from "../components-overview/UploadDisplayLogo";


const UserAccountDetails = ({ selectedUser, resetPassword, toggleModal }) => (
  
  <Card small className="mb-4">
    <CardHeader className="border-bottom">
      <h6 className="m-0">{selectedUser ? `Account Details - ${selectedUser.username}` : 'Account Details'}</h6>
    </CardHeader>
    <ListGroup flush>
      <ListGroupItem className="p-3">
        <Row>
          <Col>
            <Form>
              <Row form>
                {/* First Name */}
                <Col md="6" className="form-group">
                  <label htmlFor="feFirstName">Username</label>
                  <FormInput
                    disabled
                    id="feFirstName"
                    placeholder="Username"
                    value={selectedUser ? selectedUser.username : 'username'}
                  />
                </Col>
                {/* Email */}
                <Col md="6" className="form-group">
                  <label htmlFor="feEmail">Email</label>
                  <FormInput
                    disabled
                    type="email"
                    id="feEmail"
                    placeholder="Email Address"
                    value={selectedUser ? selectedUser.email : 'example@mail.com'}
                    autoComplete="email"
                  />
                </Col>

                <Col md="12" className="form-group">
                  {/* Display Picture */}
                  <label htmlFor="feImage">Display Logo</label>
                  <UploadDisplayLogo userId={selectedUser ? selectedUser.id : null} />
                </Col>

                <div className="mb-2 separator"></div>
                
                <Col md="6" className="form-group">
                  <label htmlFor="fePassword">Reset Password</label>
                  <Button disabled={selectedUser ? false : true} className="d-flex" theme="primary" onClick={() => { resetPassword(selectedUser.email) }}>Send Recovery Email</Button>
                </Col>
                <Col md="6" className="form-group">
                  <label htmlFor="fePassword">Delete User</label>
                  <Button className="d-flex" theme="danger" onClick={() => { toggleModal() }}>Delete User</Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </ListGroupItem>
    </ListGroup>
  </Card>
);

UserAccountDetails.propTypes = {
  /**
   * The component's title.
   */
  title: PropTypes.string
};

UserAccountDetails.defaultProps = {
  title: "Account Details"
};

export default UserAccountDetails;
